// src/frontend/constants/events.js
export const SOCKET_EVENTS = {
    JOIN_ROOM: 'joinRoom',
    LEAVE_ROOM: 'leaveRoom',  // Dein Backend hat 'leaveRoom' – passe an
    TEXT_CHANGE: 'textChange',
    UPDATE_TEXT: 'updateText',
    UPDATE_USERS: 'updateUsers',
    UPDATE_FILES: 'updateFiles',
    IS_ROOM_CREATOR: 'isRoomCreator',
    ROOM_DESTROYED: 'roomDestroyed',
    DESTROY_ROOM: 'destroyRoom',
    FILE_UPLOADED: 'fileUploaded',
    FILE_DELETED: 'fileDeleted',
    GLOBAL_NOTIFICATION: 'globalNotification',

};